export default __webpack_public_path__ + "static/media/push-down.3ee595e2.svg";